import { render, staticRenderFns } from "./AssignVehicleDriver.vue?vue&type=template&id=268a4c3b&scoped=true&"
import script from "./AssignVehicleDriver.vue?vue&type=script&lang=js&"
export * from "./AssignVehicleDriver.vue?vue&type=script&lang=js&"
import style0 from "./AssignVehicleDriver.vue?vue&type=style&index=0&id=268a4c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a4c3b",
  null
  
)

export default component.exports